import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class OrganisationApiService extends ApiService {
  static async getSubscriptionDetails(): Promise<IServiceResponse<object>> {
    return this.axios.get('billing/subscription')
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async submitInvoiceDetails(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('billing/invoice-details', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async addPaymentMethod(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('billing/add-payment-method', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getInvoices(): Promise<IServiceResponse<object>> {
    return this.axios.get('billing/invoices')
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async updateDrillSettings(data: { asset_colors?: string[], line_colors?: string[] }): Promise<IServiceResponse<object>> {
    return this.axios.post('organisation/drill-settings', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getFilters(type: string): Promise<any> {
    return this.axios.get(`organisation/filters/${type}`)
      .then((response: AxiosResponse<any>) => response.data)
  }

  static async updateFilters(type: string, filters: object): Promise<any> {
    return this.axios.post(`organisation/filters/${type}`, { filters })
      .then((response: AxiosResponse<any>) => response.data)
  }

  static async getEventColors(): Promise<{ defaults: Record<string, string>, overrides: Record<string, string> }> {
    return this.axios.get('organisation/event-colors')
      .then((response: AxiosResponse<{ defaults: Record<string, string>, overrides: Record<string, string> }>) => response.data)
  }

  static async updateEventColors(eventTypeColors: Record<string, string | null>): Promise<any> {
    return this.axios.post('organisation/event-colors', { event_type_colors: eventTypeColors })
      .then((response: AxiosResponse<any>) => response.data)
  }
}
